var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8214 20.4269H21.125V10.5608C21.125 6.46641 18.0984 3.08292 14.1607 2.51998V1.39118C14.1607 0.749888 13.6413 0.230469 13 0.230469C12.3587 0.230469 11.8393 0.749888 11.8393 1.39118V2.51998C7.90156 3.08292 4.875 6.46641 4.875 10.5608V20.4269H4.17857C3.66496 20.4269 3.25 20.8419 3.25 21.3555V22.284C3.25 22.4117 3.35446 22.5162 3.48214 22.5162H9.75C9.75 24.3095 11.2067 25.7662 13 25.7662C14.7933 25.7662 16.25 24.3095 16.25 22.5162H22.5179C22.6455 22.5162 22.75 22.4117 22.75 22.284V21.3555C22.75 20.8419 22.335 20.4269 21.8214 20.4269ZM13 23.909C12.231 23.909 11.6071 23.2852 11.6071 22.5162H14.3929C14.3929 23.2852 13.769 23.909 13 23.909ZM6.96429 20.4269V10.5608C6.96429 8.94743 7.59107 7.4327 8.73147 6.2923C9.87188 5.1519 11.3866 4.52511 13 4.52511C14.6134 4.52511 16.1281 5.1519 17.2685 6.2923C18.4089 7.4327 19.0357 8.94743 19.0357 10.5608V20.4269H6.96429Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.05d7340fcc5b25555c0b93394c7a1537.svg";
export { ForwardRef as ReactComponent };